import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "validationMessage",
    "address",
    "address2",
    "city",
    "state",
    "zipcode",
    "country",
    "useAsPickUp",
    "continueButton",
    "schedulingButtons",
  ];

  toggleButtons() {
    const checked = this.useAsPickUpTarget.checked;
    this.continueButtonTarget.hidden = checked;
    this.schedulingButtonsTarget.hidden = !checked;
  }

  async continue(event) {
    event.preventDefault();
    if (!this.isValid()) return;

    this.dispatch("homeAddressComplete", { prefix: false });

    if (this.useAsPickUpTarget.checked && (await this.isAddressInZone())) {
      this.copyToPickUpAddress();
    } else {
      this.showPickUpPoints();
    }
  }

  skipToStudent(event) {
    this.skipPickUpStep(event, '[data-action="click->driving-school-admin-booking-form-v2-location-details#schedulingSkipped"]');
  }

  skipToSchedule(event) {
    this.skipPickUpStep(event, '[data-driving-school-admin-booking-form-v2-location-details-target="scheduleSlotButton"]');
  }

  async skipPickUpStep(event, pickUpStepButtonSelector) {
    event.preventDefault();
    if (!this.isValid()) return;

    this.dispatch("homeAddressComplete", { prefix: false });

    if (this.useAsPickUpTarget.checked && (await this.isAddressInZone())) {
      this.copyToPickUpAddress();
      document.querySelector(pickUpStepButtonSelector).click();
    } else {
      this.showPickUpPoints();
    }
  }

  isValid() {
    const errors = [];
    if (this.addressTarget.value.trim() === "") errors.push("Please enter an address.");
    if (this.zipcodeTarget.value.trim() === "") errors.push("Please enter a zip code.");

    if (errors.length > 0) {
      this.validationMessageTarget.innerHTML = errors.join("<br>");
      this.validationMessageTarget.hidden = false;
      return false;
    }
    this.validationMessageTarget.hidden = true;
    return true;
  }

  // Same lookup the pick-up step uses. Any failure counts as "not in zone",
  // so the admin just picks the pick-up location manually on the next step.
  async isAddressInZone() {
    const params = new URLSearchParams({
      address: this.addressTarget.value,
      zipcode: this.zipcodeTarget.value,
      city: this.cityTarget.value,
      state: this.stateTarget.value,
      country: this.countryTarget.value,
      driving_school_token: document.getElementById("us-school-token").innerHTML.trim(),
    });

    try {
      const response = await fetch(`/fetch_locations?${params.toString()}`, {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return false;

      const json = await response.json();
      return json.is_address_in_zone === true;
    } catch (e) {
      return false;
    }
  }

  copyToPickUpAddress() {
    const fields = {
      booking_location_pickup_home_work_address_value: this.addressTarget.value,
      booking_location_pickup_home_work_address_line_2_value: this.address2Target.value,
      booking_location_pickup_home_work_city_value: this.cityTarget.value,
      booking_location_pickup_home_work_state_value: this.stateTarget.value,
      booking_location_pickup_home_work_zipcode_value: this.zipcodeTarget.value,
      booking_location_pickup_home_work_country_value: this.countryTarget.value,
    };

    Object.entries(fields).forEach(([id, value]) => {
      const input = document.getElementById(id);
      if (input) input.value = value;
    });

    const addressOption = document.getElementById("booking_location_office");
    if (addressOption) addressOption.click();
  }

  showPickUpPoints() {
    const pickUpPointsOption = document.getElementById("booking_location_pickup");
    if (!pickUpPointsOption) return;

    pickUpPointsOption.checked = true;
    pickUpPointsOption.dispatchEvent(new Event("click", { bubbles: true }));
    pickUpPointsOption.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
